<template>
  <button :class="['tab-pill-button', active ? 'active' : '']" @click.prevent="onClicked"><slot /></button>
</template>


<style lang="scss" scoped>
.tab-pill-button {
  box-sizing: content-box;
  background-color: transparent;
  font-weight: 600;
  margin: 0 6px;
  font-size: 13px;
  border-radius: 10px;
  padding: 2px 8px;
  border: 1px solid transparent;
  cursor: pointer;
  color: $general-body-text-color;
}
.tab-pill-button.active {
  font-weight: 600;
  color: $button-primary-text-color;
  background-color: $button-primary-color;
}
.tab-pill-button:not(.active):hover {
  border: 1px solid #e0e0e0;
}

</style>

<script>
export default {
  name: 'TabPillButton',
  model: {
    event: 'update'
  },
  props: {
    tabid: String,
    value: String
  },
  computed: {
    active() {
      return this.value == this.tabid
    }
  },
  methods: {
    onClicked() {
      this.$emit('update', this.tabid)
    }
  }
}
</script>